$(document).ready(function () {
  setTimeout(() => {
    let userCheck = document.getElementById("user-is-logged")
    if (userCheck.dataset.isLogged === "false" && location.pathname !== "/account/register" && location.pathname !== "/account/login") {
      document.getElementById("theModal").open();
    }
  }, 180000)
  
  class IaModal extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' }); // Attach a Shadow DOM
  
      // create modal structure
      this.shadowRoot.innerHTML = `
        <style>
          .the-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: none;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
  
          .the-modal-content {
            background-color: white;
            padding: 1rem;
            border-radius: 4px;
            width: 80%;
            position: relative;
            max-width: 768px;
          }
  
          .the-close-button {
            position: absolute;
            top: 0px;
            right: 16px;
            cursor: pointer;
            font-size: 20px;
          }
          
          @media only screen and (min-width: 768px) {
            .the-modal-content {
              max-width: 50%;
            }
          }
        </style>
  
        <div class="the-modal">
          <div class="the-modal-content">
            <span class="the-close-button">&times;</span>
            <slot></slot>
          </div>
        </div>
      `;
  
      // bind event listeners
      this.shadowRoot.querySelector('.the-close-button').addEventListener('click', () => this.close());
      this.shadowRoot.querySelector('.the-modal').addEventListener('click', (event) => {
        if (event.target === this.shadowRoot.querySelector('.the-modal')) {
          this.close();
        }
      });
    }
  
    open() {
      this.shadowRoot.querySelector('.the-modal').style.display = 'flex';
    }
  
    close() {
      this.shadowRoot.querySelector('.the-modal').style.display = 'none';
    }
  }
  
  // document.getElementById('theModal').open();
  customElements.define('ia-modal', IaModal);

  $(".open-button").click(function () {
    document.getElementById('theModal').open();
  });

  $(".cancel").click(function () {
    document.getElementById('theModal').close();
  });

  //custom arrow at the product page slider
  $(document).on("click", ".nextt", function () {
    var selected_variant = $(".first-color-option").attr("data-color").trim();
    var aa = $('.cstm-small-images li button[aria-current="true"]');
    var words = selected_variant.split(/\s+/); // Assuming `selected_variant` contains the words you want to match
    var regex = new RegExp(words.join('|'), 'i'); // Create a regular expression to match any word in the array
    var nextLi = aa.parents("li").nextAll('li').filter(function () {
      return regex.test($(this).attr('thumbnail-color'));
    });

    if (nextLi.length > 0) {
      aa.removeAttr('aria-current');
      nextLi.first().find("button").trigger("click");
      nextLi.first().find("button").attr("aria-current", true);
    }
  });

  $(document).on("click", ".prevv", function () {
    var selected_variant = $(".first-color-option").attr("data-color").trim();
    var aa = $('.cstm-small-images li button[aria-current="true"]');
    var words = selected_variant.split(/\s+/); // Assuming `selected_variant` contains the words you want to match
    var regex = new RegExp(words.join('|'), 'i'); // Create a regular expression to match any word in the array
    var prevLi = aa.parents("li").prevAll('li').filter(function () {
      return regex.test($(this).attr('thumbnail-color'));
    });

    if (prevLi.length > 0) {
      aa.removeAttr('aria-current');
      prevLi.first().find("button").trigger("click");
      prevLi.first().find("button").attr("aria-current", true);
    }
  });
});

$(document).ready(function () {
  //custom add to cart --- START
  $(".cstm_addcartBtn button").click(function () {
    $(".cstmErrMsg").remove();
    var formData = { 'items': [] };
    $(".eachsize.activeSize select").each(function () {
      const id = $(this).data("id");
      const quantity = $(this).val();
      if (quantity > 0) {
        formData.items.push({
          'id': parseInt(id),
          'quantity': parseInt(quantity)
        });
      }
    });

    var allQuantitiesZero = true;
    $.each(formData.items, function (index, item) {
      if (item.quantity !== 0) {
        allQuantitiesZero = false;
        return false;
      }
    });

    if (allQuantitiesZero == false) {
      $(this).find(".loading-overlay__spinner").removeClass("hidden");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (data) {
          $("cart-drawer").addClass("active");
          $(".cstm_addcartBtn button").find(".loading-overlay__spinner").addClass("hidden");
          var idMine = $('.cart-items tbody tr').length;

          fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
              // Bold:Subs
              if (typeof window.BOLD !== 'undefined'
                && typeof window.BOLD.common !== 'undefined'
                && typeof window.BOLD.common.cartDoctor !== 'undefined') {
                // NOTE: "cart" should be the variable containing the cart json data
                data = window.BOLD.common.cartDoctor.fix(data);
              }
              // Bold:Subs
              if (data.item_count > 0) {
                $('#CartDrawer-CartItems').html('');
                $('.drawer').removeClass('is-empty');
                $('cart-drawer-items').removeClass('is-empty');
                var idMine = $('.cart-items tbody tr').length;

                var eachHtml = '';
                $.each(data.items, function (i, data) {
                  idMine++;
                  var totalAmt = ((data.final_line_price) / 100).toFixed(2);
                  eachHtml += '<tr id="CartDrawer-Item-' + idMine + '" class="aa cart-item" role="row"> <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"> <a href="' + data.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a> <img class="cart-item__image" src="' + data.image + '&width=300" alt="' + data.product_title + '" loading="lazy" width="150" height="225"> </td> <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="' + data.url + '" class="cart-item__name h4 break">' + data.product_title + '</a><div class="product-option ' + (data.original_price) + '"> <span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="' + data.key + '" style="display:none !important;"></span><div class="money-details"></div><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="' + data.key + '" style="display:none !important;"></span><span class="eachqtyprc" data-item-key="' + data.key + '" style="visibility: visible;" data-line-total="' + totalAmt + '">$' + (data.original_price) / 100 + '</span><div class="money-details"></div></div><dl><div class="product-option"> <dt>Color:</dt> <dd> ' + data.options_with_values[0].value + ', </dd> </div><div class="product-option"> <dt>Size:</dt> <dd> ' + data.options_with_values[1].value + ' </dd> </div></dl> <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul> </td> <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"> <div class="loading-overlay hidden"> <div class="loading-overlay__spinner"> <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg> </div> </div> <div class="aa' + totalAmt + 'cart-item__price-wrapper"><div class="each_qty_total">$' + totalAmt + '</div> </div> </td> <td class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity"> <quantity-popover> <div class="cart-item__quantity-wrapper quantity-popover-wrapper"> <div class="quantity-popover-container"> </div> <cart-remove-button id="CartDrawer-Remove-' + idMine + '" data-index="' + idMine + '"> <button type="button" class="button button--tertiary cart-remove-button" aria-label="' + data.product_title + '" data-variant-id="' + data.id + '"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"> <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path> <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path> </svg> </button> </cart-remove-button> </div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"> <small class="cart-item__error-text"></small> <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"> <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle> <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle> <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path> <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"> </path></svg> </div> </quantity-popover> </td> </tr>';

                });
                var tableHead = '<thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead>';
                $('#CartDrawer-CartItems').html('<div class="drawer__cart-items-wrapper"><div class="top-cart-table"><table class="cart-items" role="table">' + tableHead + '<tbody role="rowgroup">' + eachHtml + '</tbody></table></div></div>');

                var qtyhtml = '<div  class="cart-count-bubble"><span aria-hidden="true">' + data.item_count + '</span><span class="visually-hidden">' + data.item_count + ' item</span></div>';
                $("#cart-icon-bubble").append(qtyhtml);

                var minePrice = ((data.total_price) / 100).toFixed(2);

                var totalAmtHtml = '<div class="totals" role="status"><h2 class="totals__total">Estimated total</h2><p class="totals__total-value money"><div class=""></div><span style="visibility: visible;">$ ' + minePrice + '</span><div class="money-details"></div></p></div><small class="tax-note caption-large rte">Taxes, discounts and shipping calculated at checkout</small>';
                $(".cart-drawer__footer").html(totalAmtHtml);
                if (data.item_count > 0) {
                  $("#CartDrawer").find(".drawer__inner-empty").remove();
                  $("#CartDrawer-Checkout").removeAttr("disabled");
                }
              }

              if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                typeof BOLD.common.eventEmitter.emit === 'function') {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
              }
            });
        },
        error: function (error) {
          $("cart-drawer").addClass("active");
          $(".cstm_addcartBtn button").find(".loading-overlay__spinner").addClass("hidden");
          var idMine = $('.cart-items tbody tr').length;
          getUpdatedCart();
          var warningMsg = '<b style="color:red;">Some product may not be added to cart</b><br>';
          $(".cstm_addcartBtn.product-form__buttons").before('<p class="cstmErrMsg">' + warningMsg + error.responseJSON.description + '</p>');
        },
        complete: function (data) {
          $(".cstm_addcartBtn button").find(".loading-overlay__spinner").addClass("hidden");
        }
      });
    }
    else {
      alert("Please select quantity atleast for one size");
    }
  });
  //custom add to cart --- END

  // Onload trigger click on the currently selected color --- START 
  var curcol = $(".first-color-option").attr("data-color");
  $(".color_swatches  input").each(function () {
    if ($(this).val() != curcol) {
      $(this).trigger('click');
    }
  });
  setTimeout(function () {
    $(".color_swatches  input").each(function () {
      if ($(this).val() == curcol) {
        $(this).trigger('click');
      }
    });
  }, 0);

  $(".upc_details li").each(function () {
    $(this).hasClass(curcol) ? $(this).show() : $(this).hide();
  });
  // Onload trigger click on the currently selected color --- END
});


//Get updated cart 
function getUpdatedCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      // Bold:PRE
      if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        // NOTE: "cart" should be the variable containing the cart json data
        data = window.BOLD.common.cartDoctor.fixItem(data);
      }
      // Bold:PRE
      if (data.item_count > 0) {
        $('#CartDrawer-CartItems').html('');
        $('.drawer').removeClass('is-empty');
        $('cart-drawer-items').removeClass('is-empty');
        var idMine = $('.cart-items tbody tr').length;

        var eachHtml = '';
        $.each(data.items, function (i, data) {
          idMine++;
          // var totalAmt  =  ((data.final_line_price)/100).toFixed(2);
          var totalAmt = ((data.final_line_price) / 100);

          // eachHtml += '<tr id="CartDrawer-Item-'+idMine+'" class="bb cart-item" role="row"> <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"> <a href="'+data.url+'" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a> <img class="cart-item__image" src="'+data.image+'&width=300" alt="'+data.product_title+'" loading="lazy" width="150" height="225"> </td> <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="'+data.url+'" class="cart-item__name h4 break">'+data.product_title+'</a><div class="product-option"> <span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="'+data.key+'" style="display:none !important;"></span><div class="money-details"></div><span class="money pre-money" data-item-key="'+data.key+'" style="visibility: visible;" data-line-total="'+totalAmt+'">$'+(data.original_price)/100 +'.00</span><div class="money-details"></div></div><dl><div class="product-option"> <dt>Color:</dt> <dd> '+data.options_with_values[0].value+', </dd> </div><div class="product-option"> <dt>Size:</dt> <dd> '+data.options_with_values[1].value+' </dd> </div></dl> <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul> </td> <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"> <div class="loading-overlay hidden"> <div class="loading-overlay__spinner"> <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg> </div> </div> <div class="cart-item__price-wrapper"><span class="price price--end money" data-line-index="'+idMine+'" data-line-total=""> <span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_total" data-item-key="'+data.key+'" style="display:none !important;"></span><div class="money-details"></div><span class="money pre-money" data-item-key="'+data.key+'" data-line-total="'+totalAmt+'" style="visibility: visible;">$'+totalAmt+'</span><div class="money-details"></div></span></div> </td> <td class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity"> <quantity-popover> <div class="cart-item__quantity-wrapper quantity-popover-wrapper"> <div class="quantity-popover-container"> </div> <cart-remove-button id="CartDrawer-Remove-'+idMine+'" data-index="'+idMine+'"> <button type="button" class="button button--tertiary cart-remove-button" aria-label="'+data.product_title+'" data-variant-id="'+data.id+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"> <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path> <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path> </svg> </button> </cart-remove-button> </div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"> <small class="cart-item__error-text"></small> <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"> <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle> <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle> <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path> <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"> </path></svg> </div> </quantity-popover> </td> </tr>';
          eachHtml += '<tr id="CartDrawer-Item-' + idMine + '" class="aa cart-item" role="row"> <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"> <a href="' + data.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a> <img class="cart-item__image" src="' + data.image + '&width=300" alt="' + data.product_title + '" loading="lazy" width="150" height="225"> </td> <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="' + data.url + '" class="cart-item__name h4 break">' + data.product_title + '</a><div class="product-option ' + (data.original_price) + '"> <span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="' + data.key + '" style="display:none !important;"></span><div class="money-details"></div><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="' + data.key + '" style="display:none !important;"></span><span class="eachqtyprc" data-item-key="' + data.key + '" style="visibility: visible;" data-line-total="' + totalAmt + '">$' + (data.original_price) / 100 + '</span><div class="money-details"></div></div><dl><div class="product-option"> <dt>Color:</dt> <dd> ' + data.options_with_values[0].value + ', </dd> </div><div class="product-option"> <dt>Size:</dt> <dd> ' + data.options_with_values[1].value + ' </dd> </div></dl> <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul> </td> <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"> <div class="loading-overlay hidden"> <div class="loading-overlay__spinner"> <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg> </div> </div> <div class="aa' + totalAmt + 'cart-item__price-wrapper"><div class="each_qty_total">$' + totalAmt + '</div> </div> </td> <td class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity"> <quantity-popover> <div class="cart-item__quantity-wrapper quantity-popover-wrapper"> <div class="quantity-popover-container"> </div> <cart-remove-button id="CartDrawer-Remove-' + idMine + '" data-index="' + idMine + '"> <button type="button" class="button button--tertiary cart-remove-button" aria-label="' + data.product_title + '" data-variant-id="' + data.id + '"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"> <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path> <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path> </svg> </button> </cart-remove-button> </div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"> <small class="cart-item__error-text"></small> <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"> <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle> <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle> <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path> <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"> </path></svg> </div> </quantity-popover> </td> </tr>';

        });
        var tableHead = '<thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead>';
        $('#CartDrawer-CartItems').html('<div class="drawer__cart-items-wrapper"><div class="top-cart-table"><table class="cart-items" role="table">' + tableHead + '<tbody role="rowgroup">' + eachHtml + '</tbody></table></div></div>');

        var qtyhtml = '<div  class="cart-count-bubble"><span aria-hidden="true">' + data.item_count + '</span><span class="visually-hidden">' + data.item_count + ' item</span></div>';
        $("#cart-icon-bubble").append(qtyhtml);

        console.log(data);
        var minePrice = ((data.total_price) / 100).toFixed(2);
        // console.log("text1111",minePrice);
        var totalAmtHtml = '<div class="totals" role="status"><h2 class="totals__total">Estimated total</h2><p class="totals__total-value money"><div class=""></div><span style="visibility: visible;">$ ' + minePrice + '</span><div class="money-details"></div></p></div><small class="tax-note caption-large rte">Taxes, discounts and shipping calculated at checkout</small>';
        $(".cart-drawer__footer").html(totalAmtHtml);
        if (data.item_count > 0) {
          $("#CartDrawer").find(".drawer__inner-empty").remove();
          $("#CartDrawer-Checkout").removeAttr("disabled");
        }
      }
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
        typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    });
}

// when single color is available with multiple sizes then change do not work on load then this click function came into existance for single color only
$(document).on('click', 'input[name="Color"]', function () {
  if ($(".color_swatches input").length == 1) {
    var varOptFront = document.querySelector(".variant-option");

    $('.variant-option').each(function () {
      var id = $(this).data('idd');
      var quantity = $(this).data('qty');
      var size = $(this).data("size");
      var htm = $(this).html();

      variantDatas.push({ id: id, quantity: quantity, size: size, htm: htm });
    });

    var curSelColor = $(this).val();
    $(".first-color-option span").text(curSelColor);
    $(".first-color-option").attr("data-color", curSelColor);

    $(".upc_details li").each(function () {
      $(this).hasClass(curSelColor) ? $(this).show() : $(this).hide();
    });

    $(".product-form__input .quantity-select").remove();
    setTimeout(function () {
      $(".eachsize").removeClass("activeSize");
      $(".eachsize").removeClass("inactiveSize");

      variantDatas.forEach((productForm) => {
        $(".eachsize").each(function () {
          if ($(this).find("input").val() == productForm.size) {
            $(this).append(productForm.htm);
          }
        });
      });

      let availableSizess = variantDatas.filter(function (sizes) {
        return sizes.quantity > 0;
      }).map(function (sizes) {
        return sizes.size;
      });

      $(".eachsize").each(function () {
        if (availableSizess.includes($(this).data("sizeopt"))) {
          $(this).addClass("activeSize");
        } else {
          $(this).addClass("inactiveSize");
        }
      });

      if ($(".size-btns").hasClass("userLogin")) {
        $(".js.product-form__input.size-btns ").show();
      }
      else {
        $(".js.product-form__input.size-btns ").hide();
      }

      variantDatas = [];
    }, 0);
  }
});

// function formatNumberWithCommas(number) {
//     // Convert the number to a string and split it into parts
//     var parts = number.toString().split('.');
//     console.log(parts);
//     // Add commas for thousands and lakhs
//     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

//     // Join the parts back together
//     return parts.join('.');
// }
